import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed544a04"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"min-height":"55vh","background":"url(/images/banner.png)","background-repeat":"no-repeat","background-size":"cover","background-position":"center"},
  class: "px-4 py-20 flex items-center"
}
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-white my-6 text-center lg:text-left text-56px lg-text-96px" }, [
  /*#__PURE__*/_createTextVNode(" Bring back the forest."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Now. ")
], -1))
const _hoisted_4 = { class: "flex flex-wrap justify-center lg:justify-start space-y-6 sm:space-y-0 sm:space-x-6 px-0 md:px-10 w-40 md:w-full mx-auto" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Start Planting ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Read Whitepaper ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-center font-medium lg:text-left my-6 text-24px" }, [
  /*#__PURE__*/_createTextVNode(" The future of our planet and the chance to save it"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("is in our hands. ")
], -1))

import { Props as ButtonProps } from '../Base/BaseButton.vue';
import { useRouter } from 'vue-router';

interface UsedButtonProps {
  outlined?: boolean;
  colorScheme?: ButtonProps['colorScheme'];
}


export default /*#__PURE__*/_defineComponent({
  props: {
    outlined: { type: Boolean },
    colorScheme: { default: 'white' }
  },
  setup(__props: any) {

const router = useRouter();


const openDonate = async () => {
  router.push('/donate');
};

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_BaseButton, {
          outlined: __props.outlined,
          "color-scheme": __props.colorScheme,
          rounded: "",
          class: "btn--landing text-16px lg-text-18px font-semibold py-4 lg:py-5 uppercase",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openDonate()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["outlined", "color-scheme"]),
        _createVNode(_component_BaseButton, {
          class: "btn--landing text-16px lg-text-18px font-semibold py-4 lg:py-5 uppercase",
          style: {"text-shadow":"2px 2px 2px #000"},
          "color-scheme": "white",
          rounded: "",
          outlined: ""
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _hoisted_7
    ])
  ]))
}
}

})